export const theme = {
  colors: {
    primary: '#6200ee',
    background: '#00000014',
    text: '#000000b3',
    success: '#135e01',
    white: '#ffffff',
    dark: '#333333',
  },
  fonts: {
    fontFamily: 'Roboto, sans-serif',
  },
};
